export default "__VITE_ASSET__DDbe_9QJ__"